import $http from "@/helpers/http";
import Logger from "@/helpers/logger";

class BundleApi {
  getBundleList() {
    try {
      return $http.post("panel/bundle/list", {
        entitiesToInclude: ["OrderDetails"],
      });
    } catch (e) {
      Logger.error("`getBundleList` api", e);
      return Promise.reject(e);
    }
  }
}

const bundleApi = new BundleApi();

export default bundleApi;
